// extracted by mini-css-extract-plugin
module.exports = {"banner":"_d1ea5d83","printLink":"_efea4686"};